import React, { useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as ArrowDown } from '../../SVGAssets/arrow-down.svg';
import { ReactComponent as LevelsIcon } from '../../SVGAssets/up-down-carets.svg';

const SiteSeeLevelsGuide = () => {
  const { isMobile, siteSeeName, actionWord } = useContext(SiteSeeContext);

  return (
    <>
      {`${actionWord} the`}

      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        {isMobile ? <LevelsIcon /> : <ArrowDown />}
      </span>

      icon
      {' '}
      {isMobile ? `in the ${siteSeeName} control bar below ` : ''}
      to explore residences and amenities on other community levels.
    </>
  );
};

export default SiteSeeLevelsGuide;
